<div class="flex-container" cvInvisionRuleItemDirective [data]="directiveData">
    <div class="rule-title">
        <div class="rule-title-wrapper">
            <i class="fas" 
                [ngClass]="{
                    'fa-exclamation-triangle': ruleViolation.messageType === ruleMessageType.Warning,
                    'fa-ban': ruleViolation.messageType === ruleMessageType.Error,
                    'fa-check': ruleViolation.messageType === ruleMessageType.Info
                }"></i>

            <h6 *ngIf="compareWorkflowSections(ruleWorkFlow.section, ruleWorkflowSection.LIST)"
                title="{{ruleViolation.displayText}}">
                {{ruleViolation.displayText}}
            </h6>
            <h6 *ngIf="compareWorkflowSections(ruleWorkFlow.section, ruleWorkflowSection.DETAIL)"
                [ngClass]="{
                    'invisible': ruleItem.isCollapsed
                }">
                {{ruleViolation.displayText}}
            </h6>
        </div>
    </div>
    <div class="rule-action">
        <div class="rule-actions">
            <cv-schema-render-rule-actions 
                [ruleViolation]="ruleViolation"
                [activeActions]="activeActions"
                [ruleWorkFlow]="ruleWorkFlow"
                [path]="path">
            </cv-schema-render-rule-actions>
            
            <button class="btn btn-sm btn-open-rule" title="Open Rule"
                *ngIf="version === roomRulesVersionDesign.FULL_WIDTH && ruleWorkFlow.section === ruleWorkflowSection.LIST || ruleWorkFlow.section === ruleWorkflowSection.DETAIL"
                (click)="changeRuleFlow(ruleWorkflowSection.DETAIL , ruleViolation);"
                [attr.aria-expanded]="!ruleItem.isCollapsed">
                <i [class]="ruleItem.isCollapsed ? 'fas fa-angle-up' :'fas fa-angle-down'"></i>
            </button>

            <button class="btn btn-sm btn-open-rule" title="Open Rule"
                *ngIf="version === roomRulesVersionDesign.INLINE && ruleWorkFlow.section === ruleWorkflowSection.LIST"
                (click)="changeRuleFlow(ruleWorkflowSection.DETAIL, ruleViolation)" >
                <i class="fas fa-angle-right"></i>
            </button>

        </div>
    </div>
</div>

<div class="rule-body-collapse" 
    #collapse="ngbCollapse" 
    [(ngbCollapse)]="!ruleItem.isCollapsed"
    *ngIf="version === roomRulesVersionDesign.FULL_WIDTH">
    <h6 class="rule-title-text">
        {{ruleViolation.displayText}}
    </h6>
    <cv-schema-render-display-rule-information
        [path]="path"
        [options]="{displayTitle: false}"
        [activeActions]="activeActions"
        [ruleViolation]="ruleViolation">
    </cv-schema-render-display-rule-information>
</div>
